/**
 * Сиговые — 14 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const СИГОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'whitefish',
        семейство: 'сиговые',
        latin: 'Coregonus lavaretus',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 5,
        typicalKg: 0.8,
        typicalLengthM: 0.35,
        depthM: 8,
        depthBandM: 4,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 10, макс: 18 },
        течение: 'слабое',
        держится: ['бровка', 'твёрдое_дно', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'spinner', вес: 0.2 },
        ],
    },
    {
        id: 'vendace',
        семейство: 'сиговые',
        latin: 'Coregonus albula',
        повадка: 'холодолюбивый',
        minKg: 0.02,
        maxKg: 0.5,
        typicalKg: 0.08,
        typicalLengthM: 0.16,
        depthM: 10,
        depthBandM: 5,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'массовая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 16 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 11, по: 12 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'peled',
        семейство: 'сиговые',
        latin: 'Coregonus peled',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 3,
        typicalKg: 0.5,
        typicalLengthM: 0.3,
        depthM: 6,
        depthBandM: 3,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 10, макс: 18 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 10, по: 12 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'червь', вес: 0.2 },
        ],
    },
    {
        id: 'omul',
        семейство: 'сиговые',
        latin: 'Coregonus migratorius',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 3,
        typicalKg: 0.6,
        typicalLengthM: 0.33,
        depthM: 12,
        depthBandM: 6,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 15 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'рачок', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'broad_whitefish',
        семейство: 'сиговые',
        latin: 'Coregonus nasus',
        повадка: 'холодолюбивый',
        minKg: 0.3,
        maxKg: 6,
        typicalKg: 1.2,
        typicalLengthM: 0.42,
        depthM: 7,
        depthBandM: 3,
        сложение: 'высокотелое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 16 },
        течение: 'слабое',
        держится: ['ил', 'твёрдое_дно', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'ракушка', вес: 0.2 },
        ],
    },
    {
        id: 'muksun',
        семейство: 'сиговые',
        latin: 'Coregonus muksun',
        повадка: 'холодолюбивый',
        minKg: 0.4,
        maxKg: 8,
        typicalKg: 1.5,
        typicalLengthM: 0.45,
        depthM: 9,
        depthBandM: 4,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 7, макс: 15 },
        течение: 'слабое',
        держится: ['бровка', 'твёрдое_дно', 'открытая_вода'],
        стая: 'большая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'рачок', вес: 1 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
        ],
    },
    {
        id: 'nelma',
        семейство: 'сиговые',
        latin: 'Stenodus leucichthys',
        повадка: 'холодолюбивый',
        minKg: 1,
        maxKg: 25,
        typicalKg: 4,
        typicalLengthM: 0.7,
        depthM: 7,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'сумеречная',
        вода: { мин: 1, опт: 10, макс: 18 },
        течение: 'слабое',
        держится: ['бровка', 'яма', 'открытая_вода'],
        стая: 'одиночка',
        нерест: { с: 9, по: 10 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'живец', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'grayling',
        семейство: 'сиговые',
        latin: 'Thymallus thymallus',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 3,
        typicalKg: 0.5,
        typicalLengthM: 0.32,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 2, опт: 12, макс: 18 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'мушка', вес: 1 },
            { чем: 'ручейник', вес: 0.8 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'икра', вес: 0.4 },
        ],
    },
    {
        id: 'siberian_grayling',
        семейство: 'сиговые',
        latin: 'Thymallus arcticus',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 2.5,
        typicalKg: 0.45,
        typicalLengthM: 0.3,
        depthM: 1.5,
        depthBandM: 1.2,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 1, опт: 11, макс: 18 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'мушка', вес: 1 },
            { чем: 'ручейник', вес: 0.8 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'икра', вес: 0.4 },
        ],
    },
    // ── Западная и Северная Европа ──
    // Альпийские озёра, Рона, Дунай верхнего течения и мелочь, которую ловят с детства.
    {
        id: 'blaufelchen',
        семейство: 'сиговые',
        latin: 'Coregonus wartmanni',
        повадка: 'холодолюбивый',
        minKg: 0.15,
        maxKg: 1.5,
        typicalKg: 0.5,
        typicalLengthM: 0.35,
        depthM: 25,
        depthBandM: 15,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 2, опт: 8, макс: 14 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка'],
        стая: 'большая_стая',
        нерест: { с: 12, по: 1 },
        чем: [
            { чем: 'мушка', вес: 1 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
    {
        id: 'peipus_whitefish',
        семейство: 'сиговые',
        latin: 'Coregonus maraenoides',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 2.5,
        typicalKg: 0.7,
        typicalLengthM: 0.42,
        depthM: 6,
        depthBandM: 4,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 10, макс: 18 },
        течение: 'стоячая',
        держится: ['бровка', 'твёрдое_дно', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 11, по: 12 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'опарыш', вес: 0.4 },
            { чем: 'ручейник', вес: 0.4 },
        ],
    },
    // ── Восточная Европа, Кавказ, Средняя Азия и Сибирь ──
    {
        id: 'baikal_grayling',
        семейство: 'сиговые',
        latin: 'Thymallus baicalensis',
        повадка: 'холодолюбивый',
        minKg: 0.1,
        maxKg: 1.6,
        typicalKg: 0.4,
        typicalLengthM: 0.32,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 1, опт: 11, макс: 17 },
        течение: 'любое',
        держится: ['камни', 'бровка', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'рачок', вес: 1 },
            { чем: 'мушка', вес: 0.8 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'червь', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'кузнечик', вес: 0.4 },
            { чем: 'икра', вес: 0.2 },
        ],
    },
    {
        id: 'round_whitefish',
        семейство: 'сиговые',
        latin: 'Prosopium cylindraceum',
        повадка: 'холодолюбивый',
        minKg: 0.15,
        maxKg: 1.5,
        typicalKg: 0.5,
        typicalLengthM: 0.35,
        depthM: 5,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'плёночная',
        редкость: 'нечастая',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 15 },
        течение: 'сильное',
        держится: ['камни', 'твёрдое_дно', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'ручейник', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'икра', вес: 0.6 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'рачок', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
    },
    {
        id: 'humpback_whitefish',
        семейство: 'сиговые',
        latin: 'Coregonus pidschian',
        повадка: 'холодолюбивый',
        minKg: 0.2,
        maxKg: 2.5,
        typicalKg: 0.6,
        typicalLengthM: 0.4,
        depthM: 5,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'плёночная',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 0, опт: 8, макс: 16 },
        течение: 'слабое',
        держится: ['твёрдое_дно', 'бровка', 'ил'],
        стая: 'малая_стая',
        нерест: { с: 10, по: 11 },
        чем: [
            { чем: 'мотыль', вес: 1 },
            { чем: 'червь', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'ручейник', вес: 0.6 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'опарыш', вес: 0.4 },
        ],
    },
];
//# sourceMappingURL=coregonids.js.map